//# sourceMappingURL=permissions.interface.js.map


//////////////////
// WEBPACK FOOTER
// ./~/pdfmake-wrapper/lib/interfaces/permissions.interface.js
// module id = 1180
// module chunks = 4